import React, { useState } from "react";
import { Animation } from "../../../../../../components";
import useSelectUser from "../../../SelectUser/SelectUser.hooks";
import { FormattedMessage } from "react-intl/lib";
import { getCurrency } from "../../../../../../services/utils/tools";

export default function Summary({
  setAddCreditsToggle,
  addCreditsToggle,
  selectedPlan,
  onYearlySwitch,
  onSelectPlan,
  creditsToAdd,
  onUserSelect,
  addOnsPrice,
  minSeats,
  isVersion2,
  user,
  organizationCredits,
}) {
  const [usersToggle, setUsersToggle] = useState(false);
  const { usersAndCredits, defaultUsersAndCredits } = useSelectUser({
    planId: selectedPlan.planId,
    minSeats,
  });
  return (
    <section className={"info-checkout-section-wp"}>
      <div className={"info-checkout-hd"}>
        <div>
          <p className={"summary"}>
            <FormattedMessage id={"billing.summary"} />
          </p>
          <div className={"plan-name"} id={"select-credits"}>
            <p>{selectedPlan.name}</p>
            <div className={"dropdown"}>
              <button onClick={() => setUsersToggle(!usersToggle)}>
                {selectedPlan.numberOfSeats + " "}
                <FormattedMessage
                  id={selectedPlan.numberOfSeats === 1 ? "user" : "users"}
                />
              </button>
              <Animation.Appear
                toggle={usersToggle}
                className={"dropdown-menu show"}
                setToggle={setUsersToggle}
                style={{
                  top: -210,
                  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                  padding: 0,
                  width: "max-content",
                }}
                listStyle={{ padding: 0, overflow: "auto", height: 200 }}
              >
                <div className={"select-users-list"}>
                  <ul>
                    {usersAndCredits.map((info, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          onUserSelect(info.users, selectedPlan);
                          setUsersToggle(false);
                        }}
                      >
                        {info.users}{" "}
                        <FormattedMessage
                          id={info.users === 1 ? "user" : "users"}
                        />{" "}
                      </li>
                    ))}
                  </ul>
                </div>
              </Animation.Appear>
            </div>
          </div>
        </div>

        {isVersion2 && (
          <button
            onClick={() =>
              setAddCreditsToggle({
                ...addCreditsToggle,
                active: !addCreditsToggle.active,
              })
            }
          >
            <span>+</span> <FormattedMessage id={"billing.addMoreCredits"} />{" "}
            <span style={{ marginLeft: 3, fontSize: 14 }}>
              {addCreditsToggle.active ? (
                <i className="fas fa-chevron-circle-down"></i>
              ) : (
                <i className="fas fa-chevron-circle-up"></i>
              )}
            </span>
          </button>
        )}
      </div>
      <div className={"info-checkout-section"}>
        <div>
          <p style={{ marginBottom: -3, marginTop: 5 }}>
            <FormattedMessage id={"billing.theTotalCreditsBelow"} />
          </p>
          <div className={"credits-global-info"}>
            <span>
              <FormattedMessage
                id={
                  selectedPlan.yearly
                    ? "billing.phoneCreditsPerYear"
                    : "billing.phoneCreditsPerMo"
                }
                values={{
                  value:
                    parseInt(selectedPlan.phoneCredits) *
                      (selectedPlan.yearly ? 12 : 1) +
                    parseInt(creditsToAdd["phoneCredits"].numberOfCredits),
                }}
              />
            </span>
            <span>
              <FormattedMessage
                id={
                  selectedPlan.yearly
                    ? "billing.personalEmailCreditsPerYear"
                    : "billing.personalEmailCreditsPerMo"
                }
                values={{
                  value:
                    parseInt(selectedPlan.personalEmailCredits) *
                      (selectedPlan.yearly ? 12 : 1) +
                    parseInt(
                      creditsToAdd["personalEmailCredits"].numberOfCredits
                    ),
                }}
              />
            </span>
            <span>
              <FormattedMessage
                id={
                  selectedPlan.yearly
                    ? "billing.exportCreditsPerYear"
                    : "billing.exportCreditsPerMo"
                }
                values={{
                  value:
                    parseInt(selectedPlan.exportCredits) *
                      (selectedPlan.yearly ? 12 : 1) +
                    parseInt(creditsToAdd["exportCredits"].numberOfCredits),
                }}
              />
            </span>
          </div>
        </div>
        <div className={"plan-info-footer"}>
          <PriceInfo
            selectedPlan={selectedPlan}
            addOnsPrice={addOnsPrice}
            onYearlySwitch={onYearlySwitch}
            user={user}
            organizationCredits={organizationCredits}
          />
          <button className={"upgrade-btn cstm-btn"} onClick={onSelectPlan}>
            <FormattedMessage id={"billing.checkout"} />
          </button>
        </div>
      </div>
    </section>
  );
}
function PriceInfo({
  selectedPlan,
  addOnsPrice,
  onYearlySwitch,
  organizationCredits,
  user,
}) {
  if (selectedPlan.isCustom)
    return (
      <div style={{ marginTop: -20 }}>
        <div>
          <strong style={{ fontSize: 35 }}>
            {getCurrency(
              user,
              organizationCredits && organizationCredits.customer
            )}{" "}
            {(
              (selectedPlan.subscriptionTotal / 100 + addOnsPrice) /
              selectedPlan.numberOfMonths
            ).toFixed(2)}
          </strong>{" "}
          <span style={{ color: "#979797" }}>
            / <FormattedMessage id={"month"} />{" "}
          </span>
        </div>
        <p className={""}>
          <FormattedMessage id={"billing.youWillBeCharged"} />{" "}
          {getCurrency(
            user,
            organizationCredits && organizationCredits.customer
          )}{" "}
          {(selectedPlan.subscriptionTotal / 100 + addOnsPrice).toFixed(2) +
            " "}
          {((selectedPlan.remainingMonths &&
            selectedPlan.remainingMonths == 12) ||
            !selectedPlan.remainingMonths) && (
            <FormattedMessage
              id={"billing.forXMonths"}
              values={{
                value: selectedPlan.numberOfMonths,
              }}
            />
          )}
        </p>
      </div>
    );
  return (
    <div style={{ marginTop: -20 }}>
      <div>
        <strong style={{ fontSize: 35 }}>
          {getCurrency(
            user,
            organizationCredits && organizationCredits.customer
          )}
          {(
            (selectedPlan.yearly
              ? selectedPlan.subscriptionTotal /
                (selectedPlan.remainingMonths || 12)
              : selectedPlan.subscriptionTotal) /
              100 +
            (selectedPlan.yearly
              ? addOnsPrice / (selectedPlan.remainingMonths || 12)
              : addOnsPrice)
          ).toFixed(2)}
        </strong>{" "}
        <span style={{ color: "#979797" }}>
          / <FormattedMessage id={"month"} />{" "}
        </span>
      </div>
      {selectedPlan.yearly ? (
        <p>
          <FormattedMessage id={"billing.youWillBeCharged"} />{" "}
          {getCurrency(
            user,
            organizationCredits && organizationCredits.customer
          )}{" "}
          {(selectedPlan.subscriptionTotal / 100 + addOnsPrice).toFixed(2)}
          {((selectedPlan.remainingMonths &&
            selectedPlan.remainingMonths == 12) ||
            !selectedPlan.remainingMonths) && (
            <FormattedMessage id={"billing.yearly"} />
          )}
        </p>
      ) : (
        <p
          className={"switch-to-yearly"}
          onClick={() => onYearlySwitch("yearly")}
        >
          <span>
            <FormattedMessage id={"billing.switchToAnnually"} />
          </span>
          <small>
            <FormattedMessage id={"billing.save25%"} />
          </small>
        </p>
      )}
    </div>
  );
}
